import axios from 'axios';

export const getAllProfileSubscriptions = async ({
  profileId,
  newToken,
  limit,
  offset,
}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/subscriptions/profile/${profileId}`,
      params: { limit, offset },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const getSusbcriptionPlan = async ({ customerType, newToken }) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/subscriptions/plan`,
      params: { customerType },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const getAllCondoSubscriptions = async ({
  condoId,
  newToken,
  limit,
  offset,
}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/subscriptions/condo/${condoId}`,
      params: { limit, offset },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const removeSubscription = async ({
  id,
  extraInvoiceId,
  newToken,
} = {}) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/subscriptions/${id}`,
      params: {
        extraInvoiceId,
      },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};
